"use client";

// OutageBanner — renders the active vault_broadcasts row in channel='outage'.
// Priority 0 in the banner registry (highest — outweighs payment_failed,
// trial countdown, V2 banners). Non-dismissible: outage is status, not
// call-to-act; user can't dismiss the system being down.
//
// Visual language matches PaymentFailedBanner (red-soft tint, subtle border,
// inline-bold title + continuation). Locked copy lives in:
//   - app/scripts/outage-banner.mjs VARIANTS (operator CLI source of truth)
//   - md/operations/outage-templates.md §2 (doc)
// Banner just renders whatever `title` + `content` the active row holds.
//
// Cross-references:
//   md/operations/outage-templates.md (locked copy + playbook)
//   md/operations/launch-runbook.md §Communication
//   md/NextUp.md Cluster L #121-followup

import { useOutage } from "../lib/use-outage";

export default function OutageBanner() {
  const { activeOutage } = useOutage();
  if (!activeOutage) return null;

  return (
    <div
      role="alert"
      aria-live="assertive"
      aria-label="Service status notice"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "var(--space-3)",
        padding: "var(--space-3) var(--space-4)",
        background: "var(--color-error-soft, #fbecec)",
        border: "1px solid var(--color-error, #c44)",
        borderRadius: "var(--radius-md)",
        marginBottom: "var(--space-4)",
        fontFamily: "var(--font-primary)",
      }}
    >
      <div style={{ fontSize: "var(--font-size-sm)", color: "var(--color-text)", lineHeight: 1.5 }}>
        <span style={{ fontWeight: "var(--font-weight-semibold)" }}>{activeOutage.title}.</span>{" "}
        {activeOutage.content}
      </div>
    </div>
  );
}
